<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <base-info />
        <Row :gutter="24">
          <Col :lg="{ span: 16 }">
            <div class="card card-animate">
              <div class="card-body">
                <h4 class="card-title d-inline-block">
                  最近15天订单统计图
                </h4>
                <leftchart></leftchart>
              </div>
            </div>
          </Col>
          <Col :lg="{ span: 8 }">
            <div class="card card-animate">
              <div class="card-body">
                <h4 class="card-title d-inline-block">商品销量占比</h4>
                <rightchart></rightchart>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import baseInfo from "./base-info";
import leftchart from "./left-chart";
import rightchart from "./right-chart";

export default {
  data() {
    return {
      user: {},
      data: [
        {
          icon: "iconfont icon-gongzuotai",
          name: "账户总览",
          color: "#52c41a",
          link: "/home",
        },
        {
          icon: "iconfont icon-geren1",
          name: "个人信息",
          color: "#1890ff",
          link: "/setting/user",
        },
        {
          icon: "iconfont icon-xinxi",
          name: "短信模板",
          color: "#faad14",
          link: "/note/list",
        },
        {
          icon: "iconfont icon-heimingdan-wudarao",
          name: "接口白名单",
          color: "#722ed1",
          link: "/setting/whitelist",
        },
        {
          icon: "iconfont icon-wendang",
          name: "开发文档",
          color: "#13c2c2",
          link: "/word/note",
        },
        {
          icon: "iconfont icon-jilu",
          name: "发送记录",
          color: "#eb2f96",
          link: "/note/log",
        },
      ],
    };
  },
  created() {
  },
  
  components: { baseInfo, leftchart,rightchart },
  methods: {
   
   
  },
};
</script>

<style lang="less" scoped>
@deep: ~">>>";

.ivu-mb {
  width: 33.33%;
  position: relative;
  float: left;
  margin-bottom: 30px !important;
  text-align: center;
  cursor: pointer;
  .iconfont{
    margin-bottom: 10px;
  }
  p:hover{
    color:#2d8cf0
  }
}
.card-title {
  margin-bottom: 10px;
}
@{deep}.ivu-divider-inner-text{
  color:#999
}
.ivu-alert{
  padding-right: 8px;
}
</style>